import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireOnboarding = true }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/", { replace: true });
      return;
    }
    if (requireOnboarding && !user.onboarding_complete) {
      // Skip redirect if already in onboarding/reveal flow
      if (!location.pathname.startsWith("/onboarding") && !location.pathname.startsWith("/reveal")) {
        navigate("/onboarding/language", { replace: true });
      }
    }
  }, [user, loading, navigate, requireOnboarding, location.pathname]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: "var(--vedari-cream)" }}>
        <div className="text-body-sm animate-soft-pulse" style={{ color: "var(--vedari-ink-soft)" }}>
          A moment…
        </div>
      </div>
    );
  }
  if (!user) return null;
  return children;
}
